module.exports = __webpack_public_path__ + "img/tableLpr.45fc4734.png";